import React, { useEffect, useRef, useState } from "react";
import { Button, Stack, Typography } from "@mui/material";

const ProcessUploadArea = ({ onFileChange }) => {
  const [arquivoProcesso, setArquivoProcesso] = useState(null);
  const inputRef = useRef(null);

  const handleArquivoChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setArquivoProcesso(file);
      onFileChange(file);
    }
  };

  const formatFileName = (fileName, maxLength = 25) => {
    if (fileName.length <= maxLength) return fileName;

    const dotIndex = fileName.lastIndexOf(".");
    const name = fileName.substring(0, dotIndex);
    const ext = fileName.substring(dotIndex);
    const truncated = name.substring(0, maxLength - ext.length - 3);
    return `${truncated}...${ext}`;
  };

  useEffect(() => {
    return () => {
      setArquivoProcesso(null);
    };
  }, []);

  return (
    <Stack
      my={1}
      width="100%"
      p={2}
      gap={2}
      direction="column"
      alignItems="center"
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography fontWeight={600}>
          Petição de depósito (eletrônico):
        </Typography>

        <Button
          color="primary"
          variant="contained"
          onClick={() => inputRef.current?.click()}
        >
          Escolher arquivo
        </Button>
        <input
          type="file"
          accept="application/pdf"
          ref={inputRef}
          style={{ display: "none" }}
          onChange={handleArquivoChange}
        />
      </Stack>

      {arquivoProcesso && (
        <Typography fontSize={14} color="text.secondary">
          {formatFileName(arquivoProcesso.name)}
        </Typography>
      )}
    </Stack>
  );
};

export default ProcessUploadArea;
